
import {
  useEffect,
  useState,
} from "react";

import getBookingSubdomain from "../../../utils/getBookingSubdomain";

import {
  getBookingProperty,
} from "../../../api/bookingEngine";


const useBookingProperty = () => {

  const [property, setProperty] =
    useState(null);

  const [propertyLoading, setPropertyLoading] =
    useState(true);

  const [propertyError, setPropertyError] =
    useState("");

  const [subdomain, setSubdomain] =
    useState("");


  /* =========================================================
     LOAD PROPERTY
  ========================================================= */

  useEffect(() => {

    let mounted = true;


    const loadProperty = async () => {

      try {

        if (mounted) {
          setPropertyLoading(true);
          setPropertyError("");
        }


        const currentSubdomain =
          getBookingSubdomain();


        console.log(
          "🏨 SUBDOMAIN:",
          currentSubdomain
        );


        if (!currentSubdomain) {

          throw new Error(
            "Property not identified."
          );

        }


        if (mounted) {
          setSubdomain(
            currentSubdomain
          );
        }


        const response =
          await getBookingProperty(
            currentSubdomain
          );


        console.log(
          "🏨 PROPERTY RESPONSE:",
          response
        );


        if (!response?.success) {

          throw new Error(
            response?.message ||
            "Unable to load property."
          );

        }


        if (mounted) {

          setProperty(
            response.property
          );

        }


      } catch (error) {

        console.error(
          "❌ PROPERTY ERROR:",
          error
        );


        if (mounted) {

          setPropertyError(
            error?.message ||
            "Unable to load property."
          );

        }


      } finally {

        if (mounted) {

          setPropertyLoading(
            false
          );

        }

      }

    };


    loadProperty();


    return () => {
      mounted = false;
    };

  }, []);


  return {

    property,

    propertyLoading,

    propertyError,

    subdomain,

  };
};


export default useBookingProperty;
